import { gql } from 'apollo-angular';

import {
  SNK_PRICE_DESCRIPTOR_CHANGED_FRAGMENT, SNK_PRICE_DESCRIPTOR_FRAGMENT
} from 'graphql/fragments/snk-price-descriptor';

export const CUSTOM_LINE_PRICING_FRAGMENT = gql`
  fragment CustomLinePricingFragment on CustomLine {
    pricing {
      listPrice { ...SnkPriceDescriptorFragment }
      basePrice { ...SnkPriceDescriptorFragment }
      totalBasePrice { ...SnkPriceDescriptorFragment }
      totalSellPrice { ...SnkPriceDescriptorFragment }

      # Dealer conditions
      listPriceDiscount { ...SnkPriceDescriptorChangedFragment }
      buyPriceSurcharge { ...SnkPriceDescriptorChangedFragment }
      profitMargin { ...SnkPriceDescriptorFragment }
      
      tz { ...SnkPriceDescriptorChangedFragment }
      listPriceWithTz { ...SnkPriceDescriptorChangedFragment }

      baseDiscount { ...SnkPriceDescriptorChangedFragment }
      additionalDiscount { ...SnkPriceDescriptorChangedFragment }
      alternativeDiscount { ...SnkPriceDescriptorChangedFragment }
      positionDiscount { ...SnkPriceDescriptorChangedFragment }
    }
  }
  ${SNK_PRICE_DESCRIPTOR_FRAGMENT}
  ${SNK_PRICE_DESCRIPTOR_CHANGED_FRAGMENT}
`;
